<template>
    <div class="menu-links">
        <router-link :to="{name: 'Dashboard'}" class="link">
            <rir-icon
              class="icon"
              icon="insert"
            /> Сводка
        </router-link>
        <router-link :to="{name: 'DDS'}" class="link">
          <rir-icon
              class="icon"
              icon="support"
          /> ДДС
        </router-link>
    </div>
</template>

<script>
    export default {
        name: 'Menu',
        props: {

        }
    }
</script>

<style lang="scss">
</style>
